import { MainPhotoCell } from "@/components/MainPhotoCell";

/* A PART ROW'S ONE PHOTO — its main photo (Batch 3b), the same cell the Vehicles list uses. Tap opens every photo. */
export function PartPhotoCell({ p, onChanged, size = "w-14 h-14", testidPrefix }) {
  const count = (p?.photos || []).filter((x) => x?.file_id && !x.is_archived && !x.bytes_missing).length;
  return (
    <span onClick={(e) => e.stopPropagation()} className="shrink-0">
      <MainPhotoCell scope="part" recordId={p.id} stockNumber={p.short_code} main={p.main_photo}
        photoCount={count} countOverlay compactCount size={size} onChanged={onChanged}
        testidPrefix={testidPrefix || `part-photo-${p.short_code}`} />
    </span>
  );
}
